import { defineStore } from 'pinia'
import { ref } from 'vue'
import {
  applyTheme,
  getStoredTheme,
  resolveIsDark,
  THEME_STORAGE_KEY,
  type ThemeMode,
} from '@/shared/theme'

export const useThemeStore = defineStore('theme', () => {
  const mode = ref<ThemeMode>(getStoredTheme())
  const isDark = ref(resolveIsDark(mode.value))

  let media: MediaQueryList | null = null

  function syncDom() {
    applyTheme(mode.value)
    isDark.value = resolveIsDark(mode.value)
  }

  function onSystemPreferenceChange() {
    if (mode.value === 'system') {
      syncDom()
    }
  }

  function bindSystemListener() {
    if (media || typeof window === 'undefined') {
      return
    }
    media = window.matchMedia('(prefers-color-scheme: dark)')
    media.addEventListener('change', onSystemPreferenceChange)
  }

  function setMode(next: ThemeMode) {
    mode.value = next
    localStorage.setItem(THEME_STORAGE_KEY, next)
    syncDom()
  }

  function toggle() {
    setMode(isDark.value ? 'light' : 'dark')
  }

  syncDom()
  bindSystemListener()

  // App-lifetime singleton (bootstrapped from main.ts). No onScopeDispose —
  // that API warns / can break when the store is created outside a component scope.

  return { mode, isDark, setMode, toggle }
})
